import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Exportar evidências", -1)
const _hoisted_2 = { class: "flex flex-col gap-6 text-left" }
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-textPrimary" }, "Formato de exportação", -1)
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "text-sm font-medium text-textPrimary" }
const _hoisted_10 = { class: "text-xs text-neutral50 pl-6" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = {
  class: "w-4 h-4 text-textPrimary",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_14 = ["d"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-textPrimary" }, "Filtros", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-neutral50"
}
const _hoisted_17 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_18 = { class: "flex flex-col gap-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-textPrimary" }, [
  /*#__PURE__*/_createTextVNode(" Tipo de data "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-negative",
    "aria-hidden": "true"
  }, "*")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Selecione", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "plantao" }, "Data do plantão", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "upload" }, "Data do upload", -1)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "flex gap-3" }
const _hoisted_25 = { class: "flex-1 flex flex-col gap-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-textPrimary" }, [
  /*#__PURE__*/_createTextVNode(" Data início "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-negative",
    "aria-hidden": "true"
  }, "*")
], -1)
const _hoisted_27 = { class: "flex-1 flex flex-col gap-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold text-textPrimary" }, [
  /*#__PURE__*/_createTextVNode(" Data fim "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-negative",
    "aria-hidden": "true"
  }, "*")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-negative",
  "data-testid": "export-date-error"
}
const _hoisted_30 = { class: "flex gap-4 w-full" }
const _hoisted_31 = { class: "flex-1" }
const _hoisted_32 = { class: "flex-1" }

import { computed, ref, watch } from 'vue'
import { mdiFilterOutline } from '@mdi/js'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

import type { CheckValidationFilterTag } from '../filterTags'

export type ExportDateType = 'plantao' | 'upload'

export interface ExportPayload {
  format: 'zip' | 'pdf'
  dateType: ExportDateType
  startDate: string
  endDate: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportEvidencesModal',
  props: {
    modelValue: { type: Boolean },
    exporting: { type: Boolean },
    filterTags: {}
  },
  emits: ["update:modelValue", "export"],
  setup(__props: any, { emit }) {

const props = __props;





const FORMAT_OPTIONS = [
  {
    label: 'Arquivos separados (.zip)',
    value: 'zip' as const,
    description: 'Um arquivo por evidência, compactados em .zip'
  },
  {
    label: 'PDF único compilado',
    value: 'pdf' as const,
    description:
      'Todas as evidências em um só documento (com página de resumo), na ordem da data do plantão'
  }
]

const format = ref<'zip' | 'pdf'>('zip')
const dateType = ref<ExportDateType | ''>('')
const startDate = ref('')
const endDate = ref('')

const isDateRangeInverted = computed(
  () => !!startDate.value && !!endDate.value && endDate.value < startDate.value
)

const canExport = computed(
  () =>
    !props.exporting &&
    !!dateType.value &&
    !!startDate.value &&
    !!endDate.value &&
    !isDateRangeInverted.value
)

// Reseta os campos ao abrir o modal.
watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      format.value = 'zip'
      dateType.value = ''
      startDate.value = ''
      endDate.value = ''
    }
  }
)

function close() {
  emit('update:modelValue', false)
}

function handleExport() {
  if (!canExport.value) return

  emit('export', {
    format: format.value,
    dateType: dateType.value as ExportDateType,
    startDate: startDate.value,
    endDate: endDate.value
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-lg",
    onClose: close
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(OutlineButton, {
            text: "Cancelar",
            width: "100%",
            height: "48px",
            disabled: _ctx.exporting,
            "data-testid": "export-cancel-button",
            onClick: close
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(FilledButton, {
            text: "Exportar",
            width: "100%",
            height: "48px",
            disabled: !canExport.value,
            loading: _ctx.exporting,
            "data-testid": "export-confirm-button",
            onClick: handleExport
          }, null, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FORMAT_OPTIONS, (opt) => {
              return _createElementVNode("label", {
                key: opt.value,
                class: _normalizeClass(["flex-1 flex flex-col gap-1 cursor-pointer rounded-lg border-2 p-3 transition-colors", 
              format.value === opt.value
                ? 'border-primary bg-primary/5'
                : 'border-gray-200 hover:border-gray-300'
            ]),
                "data-testid": `export-format-${opt.value}`
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((format).value = $event)),
                    type: "radio",
                    value: opt.value,
                    class: "accent-primary"
                  }, null, 8, _hoisted_8), [
                    [_vModelRadio, format.value]
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(opt.label), 1)
                ]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(opt.description), 1)
              ], 10, _hoisted_6)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createElementBlock("svg", _hoisted_13, [
              _createElementVNode("path", {
                d: _unref(mdiFilterOutline),
                fill: "currentColor"
              }, null, 8, _hoisted_14)
            ])),
            _hoisted_15
          ]),
          (_ctx.filterTags.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Nenhum filtro ativo: a exportação leva a fila inteira. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTags, (tag) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tag.id,
                    class: "inline-flex items-center rounded-full border border-neutral30 px-3 py-1 text-xs text-textPrimary"
                  }, _toDisplayString(tag.label), 1))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateType).value = $event)),
            class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-textPrimary bg-white focus:outline-none focus:ring-2 focus:ring-primary30",
            "data-testid": "export-date-type"
          }, _hoisted_23, 512), [
            [_vModelSelect, dateType.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
              type: "date",
              class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary30",
              "data-testid": "export-start-date"
            }, null, 512), [
              [_vModelText, startDate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
              type: "date",
              class: _normalizeClass(["w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary30", { 'border-negative': isDateRangeInverted.value }]),
              "data-testid": "export-end-date"
            }, null, 2), [
              [_vModelText, endDate.value]
            ]),
            (isDateRangeInverted.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, " A data fim não pode ser anterior à data início. "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})